<template>
  <div>
    <button type="button" @click="jump()">跳转到page01</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  methods:{
    jump(){
      this.$router.push({path:'/page01'})
    }
  },
  mounted() {
    console.log("page02.mounted...")
  },
  created(){
    console.log("page02.created...")
  },
}
</script>

<style>
